/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewhint2Inputs */

const en_ticketpreviewhint2 = /** @type {(inputs: Ticketpreviewhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With the guest's name and your event picture`)
};

const de_ticketpreviewhint2 = /** @type {(inputs: Ticketpreviewhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem Namen des Gasts und deinem Eventbild`)
};

/**
* | output |
* | --- |
* | "With the guest's name and your event picture" |
*
* @param {Ticketpreviewhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewhint2 = /** @type {((inputs?: Ticketpreviewhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewhint2(inputs)
	return de_ticketpreviewhint2(inputs)
});
export { ticketpreviewhint2 as "ticketPreviewHint" }